module.exports = __webpack_public_path__ + "img/op_img-carrusel-personas-1-mobile.20f782f.jpg";